// VIBRANIAM-SPACE v2 - types.js
// Port kinds carried by the edges, and the curves used by modulation slots.

export const KIND = {
  scalar:  { label: 'scalar',  color: '#4fd8ff' },
  array:   { label: 'array',   color: '#8ef07a' },
  trigger: { label: 'trigger', color: '#ffb454' },
  force:   { label: 'force',   color: '#e0503c' },
  layer:   { label: 'layer',   color: '#c93f8e' },
  video:   { label: 'video',   color: '#ff7ba9' },
  camera:  { label: 'camera',  color: '#7d5be0' },
};

export const kindColor = (k) => KIND[k]?.color || '#8f8f9f';

/** A signal graph edge may connect scalar->array or trigger->scalar; these coerce. */
export function coerce(value, toKind) {
  if (toKind === 'scalar') {
    if (typeof value === 'number') return value;
    if (typeof value === 'boolean') return value ? 1 : 0;
    if (value && value.length) return value[0] || 0;
    return 0;
  }
  if (toKind === 'trigger') {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value > 0.5;
    return false;
  }
  if (toKind === 'array') {
    if (value && value.length !== undefined) return value;
    if (typeof value === 'number') return Float32Array.of(value);
    return EMPTY_ARRAY;
  }
  return value;
}

export const EMPTY_ARRAY = new Float32Array(0);

export const defaultForKind = (kind) => {
  if (kind === 'scalar') return 0;
  if (kind === 'trigger') return false;
  if (kind === 'array') return EMPTY_ARRAY;
  return null;
};

/** Only these kinds can drive a parameter. */
export const MODULATABLE_KINDS = new Set(['scalar', 'trigger', 'array']);

// --- modulation curves ------------------------------------------------------

export const CURVES = ['lin', 'exp', 'log', 'scurve', 'inv'];

export function applyCurve(x, curve) {
  const v = x < 0 ? 0 : x > 1 ? 1 : x;
  switch (curve) {
    case 'exp':    return v * v;
    case 'log':    return Math.sqrt(v);
    case 'scurve': return v * v * (3 - 2 * v);
    case 'inv':    return 1 - v;
    default:       return v;
  }
}

export const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
